export default "__VITE_ASSET__BUUZan25__"